import React from "react";
import { Link } from "react-router-dom";
import Header from "../../Components/Header";
import whitepaper from "../../Assets/img/whitepaper.webp";
import downicon from "../../Assets/img/downicon.webp";
import youtube from "../../Assets/img/youtube.webp";
import facebook from "../../Assets/img/facebook.webp";
import twitter from "../../Assets/img/twitter.webp";
import insta from "../../Assets/img/insta.webp";

import "../../Assets/css/whitepaper.css";
import Social from "../../Components/Social";
import Footeragain from "../../Components/Footeragain";
import Footer from "../../Components/Footer";
import whitePaper from "../../Assets/img/whitepaper.webp";
import { Button } from "bootstrap";
import mighty from "../../Assets/img/mighty.pdf";

const Whitepaper = () => {
  return (
    <>
      <Header />
      {/* White space section  */}
      <div className="meet">
        <img className="img-fluid" src={whitePaper}></img>
      </div>

      <section className="white-space-paper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="white-papper">
                <div className="white-paper-all">
                  <div className="content-wrapper">
                    <h2 className="for-respoinsive-heading">
                      OUR PRODUCTS –{" "}
                      <span> NFTS, GAMES, AND META-VERSE AT A GLANCE.</span>
                    </h2>
                    <p>
                      Since our decentralized platform is available to anyone,
                      anywhere in the world, and is completely open-source.
                      Therefore, we are continuously striving to push the
                      boundaries for innovative solutions.
                    </p>
                    <p>
                      Being a community of creatives, gamers, and NFT art
                      enthusiasts, our mission is to constantly challenge the
                      status quo and provide an online platform that promotes
                      originality and innovation through all we do.
                    </p>
                    <p>
                      Thus, we are on a mission to create a virtually-immersive
                      environment that combines diverse settings from the
                      prehistoric era of Gods and Pantheon and lets the users
                      explore historical lands, their eras, and Gods through our
                      products.
                    </p>
                  </div>
                  <div className="content-wrapper">
                    <h2>
                      {" "}
                      <span>NFTS</span>{" "}
                    </h2>
                    <p>
                      With four different tiers of NFTs, we wish to keep the
                      cycle of governance and economy in the hands of the
                      community…
                    </p>
                    <p>
                      With the unique and distinct abilities of each NFT, the
                      user can buy NFTs based on their abilities, rarity,
                      quality, strengths, and type.
                    </p>
                    <p>
                      <b>Special edition: </b>for those who are interested in
                      gaining the maximum power of the Mighty Wings Universe
                    </p>
                    <p>
                      <b> God Tier: </b>the premium type of NFTs with different
                      backgrounds, characters, tools, assets, and accessories.
                    </p>
                    <p>
                      <b>Mid Tier: </b>Animated Character NFTs with unique
                      identity and code
                    </p>
                    <p>
                      <b>Basic Tier: </b>NFTs with Floating/Hovering features.
                    </p>
                  </div>
                  <div className="content-wrapper">
                    <h2>
                      MIGHTY
                      <span>WINGS GAME</span>{" "}
                    </h2>
                    <p>
                      Using state-of-the-art technology, we have developed
                      unique campaigns to assist multi players in the game. Our
                      game can be played on PC, Consoles, and even smartphones.
                    </p>
                    <p>
                      However, the Mighty Wings gaming world isn't without a
                      surprise; the mythical, helpful, and deceiving characters
                      are always there to bring a twist to your game. They all
                      have their ultimate goal to achieve. Therefore, make sure
                      you are not easily fooled by the charms of this realm.
                    </p>
                  </div>
                  <div className="content-wrapper">
                    <h2>
                      A Self-Governing
                      <span> Meta-Verse </span>{" "}
                    </h2>
                    <p>
                      This Meta-verse is scarce and valuable where users have a
                      say in what's on the web. They can engage in various
                      activities that help them achieve their desired goals.
                      When it comes to making wealth out of this digital verse,
                      the users can utilize the Crypto tokens to have a great
                      Web3 experience.
                    </p>
                    <p>
                      From getting the community's attention in the Hall of Fame
                      to managing their assets and wealth through leaderboards,
                      the user will have 100% autonomy to maximize their gaming
                      experience. In addition, the users can engage themselves
                      in our virtual real estate business, where they can buy,
                      sell, or trade their pieces of land.
                    </p>
                  </div>
                  <h2>WHITEPAPER</h2>
                  <p>
                    To know more about our aspirations and plan, download our
                    whitepaper.
                  </p>
                  {/* 
                  <div className="white-flex">
                    <div className="my-head-things">
                      <h5>MINTS</h5>
                      <h2>45k</h2>
                    </div>

                    <div className="my-head-things">
                      <h5>SOLD</h5>
                      <h2>45k</h2>
                    </div>

                    <div className="my-head-things">
                      <h5>MINTS</h5>
                      <h2>45k</h2>
                    </div>

                    <div className="my-head-things">
                      <h5>NFTS</h5>
                      <h2>45k</h2>
                    </div>
                  </div> */}

                  <div className="white-button">
                    <button>
                      <img src={downicon}></img>{" "}
                      <a className="vt-downlaod" href={mighty} download>
                        DOWNLOAD
                      </a>
                    </button>

                    {/* <div className="dv-ul">
                            <h5>JOIN OUR SOCIAL MEDIA</h5>
                            <ul>
                                
                                <li>
                                   <Link to ="/"><img src={twitter}></img></Link>
                                </li>
                                <li><Link to ="/"><img src={facebook}></img></Link></li>
                                <li><Link to ="/"><img src={youtube}></img></Link></li>
                                <li><Link to ="/"><img src={insta}></img></Link></li>
                            </ul>

                          </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-md-3">
              <div className="my-head-things">
                <h5>MINTS</h5>
                <h2>45k</h2>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      {/* End of White space section  */}

      <Social />

      <Footer />
    </>
  );
};

export default Whitepaper;
